<template>
	<div class="add-body">
        <div class="table-box">
            <el-table
				class="grid-content"
				:data="tableData"
				:height="tableHeight"
                size='mini'
				@selection-change="handleSelectionChange"
				border>
				<el-table-column
                fixed='left'
				type="selection"
				align="center"
				width="55">
				</el-table-column>
				<!-- <el-table-column
				align="center"
                label="选择"
				width="55">
                    <template slot-scope="scope">
						<el-checkbox v-model="scope.row.status"></el-checkbox>
					</template>
				</el-table-column> -->
				<el-table-column
                    prop="unitName"
                    label="单位"
                    align="center"
                    min-width="120">
                </el-table-column>
                <el-table-column
                    prop="spec"
                    label="规格"
                    align="center"
                    min-width="120">
                </el-table-column>
                <el-table-column
                    prop="standardWeight"
                    label="标准重量"
                    align="center"
                    min-width="120">
                </el-table-column>
                <el-table-column
                    prop="defaultPrice"
                    label="默认价格（元）"
                    align="center"
                    min-width="150">
                </el-table-column>
                <el-table-column
                    prop="customPrice"
                    label="自定义单价（元）"
                    align="center"
                    min-width="150">
                    <template slot-scope="scope">
						<!-- v-if='scope.row.status'  -->
						<el-input type='number' size='mini' @blur="onBlur(scope.row)" v-model='scope.row.customPrice'></el-input>
						<!-- <span v-else>{{scope.row.customPrice}} </span> -->
					</template>
                </el-table-column>
                <el-table-column
                    prop="inventory"
                    label="库存"
                    align="center"
                    min-width="150">
                    <template slot-scope="scope">
						<!-- v-if='scope.row.status'  -->
						<el-input onkeyup="value=value.replace(/[^0-9]/g,'')" onpaste="value=value.replace(/[^0-9]/g,'')" oncontextmenu = "value=value.replace(/[^0-9]/g,'')" v-model="scope.row.inventory" @blur="onBlur1(scope.row)" size='mini'></el-input>
						<!-- <span v-else>{{scope.row.inventory}} </span> -->
					</template>
                </el-table-column>
			</el-table>
			<div class='btn-box'>
				<el-button class="btn" plain type="primary" size='small' @click="cancel">取消</el-button>
				<el-button class="btn" plain type="primary" size='small'  @click='save'>确认</el-button>
			</div>
        </div>
	</div>
</template>
<script>
export default {
	name: 'adUnit',
	props: {
		isAdd: Boolean,
		productId: String,
		goodsId: String
	},
	data () {
		return {
			tableData: [],
			ids: [],
			tableHeight: '200px'
		}
	},
	watch: {
		isAdd: {
			handler (val) {
				if (val === true) {
					this.init()
				} else {
					this.tableData = []
				}
			},
			immediate: true
		},
		goodsId: {
			handler (val) {
				console.log(val)
			},
			immediate: true
		}
	},
	methods: {
		handleSelectionChange (data) {
			this.ids = []
			console.log(data)
			for (let i = 0; i < data.length; i++) {
				this.ids.push(data[i].id)
			}
		},
		init () {
			let params = {
				id: this.productId,
				goodsId: this.goodsId,
				shopid: sessionStorage.getItem('storeid')
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/productUnit/notBind/get`,
				data: params
			}).then(res => {
				if (res.result === true) {
					this.tableData = res.data
					let a = this.tableData
					for (let i = 0; i < a.length; i++) {
						a[i].status = false
					}
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		cancel () {
			this.$emit('cancel1', false)
		},
		onBlur (data) {
			let x = data.customPrice
			var f = Math.round(x * 100) / 100
			var s = f.toString()
			var rs = s.indexOf('.')
			if (rs < 0) {
				rs = s.length
				s += '.'
			}
			while (s.length <= rs + 2) {
				s += '0'
			}
			data.customPrice = s
			console.log(data.customPrice)
		},
		onBlur1 (data) {
			if (data.inventory === '') {
				data.inventory = 0
			}
		},
		save () {
			let a = this.tableData
			let arr = []
			let idArr = this.ids
			console.log(idArr)
			for (let j = 0; j < idArr.length; j++) {
				for (let i = 0; i < a.length; i++) {
					if (a[i].id === idArr[j]) {
						arr.push(a[i])
					}
				}
			}
			if (arr.length > 0) {
				let b = arr
				for (let i = 0; i < b.length; i++) {
					b[i].productid = this.productId
				}
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIV}/shop/productUnit/add`,
					data: b
				}).then(res => {
					console.log(res)
					if (res.result === true) {
						this.$message.success('保存成功')
						this.$emit('cancel', false)
					} else {
						this.$message.error('保存失败，请重新保存！')
					}
				}).catch(() => {
					this.$message.error('保存失败，请重新保存！')
				})
			} else {
				this.$message.error('请至少选择一个单位')
			}

			console.log(this.tableData)
		}
	}
}
</script>
<style lang="stylus" scoped>

.add-body{
	.btn-box{
		margin-top :30px
		text-align:left
		.btn{
			width:30%
			margin-left :100px
		}
	}
    display: flex;
    min-width :730px;
    width :100%;
	flex-direction: column;
    height :100%;
    overflow-y :auto;
    .table-box{
        padding-bottom :10px;
        height :calc(100% - 210px)
    }
	.el-input{
		width:100px
	}
    padding-bottom :50px;
}

</style>
<style lang="stylus">
.business-body {
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
}
</style>
